export default __webpack_public_path__ + "static/chatLogo-0207e7c55cefa4cf8b3ee1d4d90b4349.png";